import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

export default function VariantTestingGuide({ title = 'Variant testing guide', rows = [] }) {
  const [open, setOpen] = useState(false);
  if (!rows.length) return null;

  return (
    <div className="border rounded-md">
      <button
        type="button"
        className="w-full flex items-center gap-2 p-3 text-sm font-medium text-left hover:bg-gray-50"
        onClick={() => setOpen((v) => !v)}
      >
        {open ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
        {title}
      </button>
      {open && (
        <div className="overflow-x-auto px-3 pb-3">
          <table className="w-full text-xs">
            <thead>
              <tr className="text-left text-gray-600 border-b">
                <th className="py-2 pr-2">Variant</th>
                <th className="py-2 pr-2">Input</th>
                <th className="py-2 pr-2">Header</th>
                <th className="py-2">Endpoint</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={`${row.variant}-${row.endpoint}`} className={row.highlight ? 'bg-blue-50 font-medium' : ''}>
                  <td className="py-2 pr-2">{row.variant}</td>
                  <td className="py-2 pr-2">{row.input}</td>
                  <td className="py-2 pr-2">{row.header}</td>
                  <td className="py-2 font-mono">{row.endpoint}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
